/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

function DataTableBodyCell({ noBorder, align, fixedWidth, children }) {
  return (
    <MDBox
      component="td"
      textAlign={align}
      py={1.5}
      px={3}
      sx={({ borders: { borderWidth, borderColor }, functions: { pxToRem } }) => ({
        fontSize: pxToRem(13),
        borderBottom: noBorder ? "none" : `${borderWidth[1]} solid ${borderColor}`,
        ...(fixedWidth && { maxWidth: 0, overflow: "hidden" }),
      })}
    >
      <MDBox
        display={fixedWidth ? "block" : "inline-block"}
        width={fixedWidth ? "100%" : "max-content"}
        color="text"
        sx={{
          verticalAlign: "middle",
          ...(fixedWidth && {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }),
        }}

      >
        {children}
      </MDBox>
    </MDBox>
  );
}

// Setting default values for the props of DataTableBodyCell
DataTableBodyCell.defaultProps = {
  noBorder: false,
  align: "left",
  fixedWidth: false,
};

// Typechecking props for the DataTableBodyCell
DataTableBodyCell.propTypes = {
  children: PropTypes.node.isRequired,
  noBorder: PropTypes.bool,
  align: PropTypes.oneOf(["left", "right", "center"]),
  fixedWidth: PropTypes.bool,
};

export default DataTableBodyCell;
